// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"ShareableLinkDialog_subtitle__34wnS"};